<div id="layout-wrapper">
  <div class="main-content ms-0 mb-10">
    <div class="page-content">
      <div id="container-home-form">
        <div class="row justify-content-center p-2 mt-5">
          <div
            [class]="
              activeStep > 0 && !formCompleted ? 'col-lg-9' : 'col-lg-4'
            ">
            <div class="text-center" *ngIf="activeStep === 0 || formCompleted">
              <img
                class="card-img img-fluid"
                src="assets/images/homepage/benchmark-logo-2.png" />
            </div>

            <!--Card Presentation-->
            <div class="text-center" *ngIf="activeStep === 0">
              <h6 class="text-muted mt-4 mb-4" style="font-size: 1.2rem">
                Congratulations On The New Move In!
              </h6>
              <button
                class="btn btn-info btn-md m-btn-schedule fw-bold"
                (click)="onCreateNew()"
                style="background-color: #3f7cbf; border-color: #3f7cbf">
                Start
              </button>
              <p class="text-center mt-1" style="font-size: 9px">
                <i class="bx bx-time-five">Takes 15 Minutes</i>
              </p>
            </div>

            <!--Card Success-->
            <div class="text-center" *ngIf="formCompleted">
              <h6 class="text-muted mt-4 mb-4" style="font-size: 1.2rem">
                Thank you! Congratulations on your new move-in! An email with a
                PDF summary of your responses will immediately be emailed to
                <button
                  disabled
                  class="plainButton"
                  style="padding: 5px 5px; font-size: 11px">
                  {{ service.model?.email }}
                </button>
              </h6>
              <h6 class="text-muted mt-4 mb-5" style="font-size: 1.2rem">
                If you have any questions, please email
                <u>support@tsolife.com</u>
              </h6>
              <h6 class="text-muted mt-4 mb-4" style="font-size: 1.2rem">
                Click below to submit a form for another new resident
              </h6>
              <button
                class="btn btn-info btn-md m-btn-schedule fw-bold"
                (click)="onCreateNew()"
                style="background-color: #3f7cbf; border-color: #3f7cbf">
                Submit Another Form
              </button>
              <p style="font-size: 9px; color: #3f7cbf" class="text-center">
                Press Enter <i class="bx bx-check-double"></i>
              </p>
            </div>

            <div
              role="application"
              class="wizard clearfix"
              *ngIf="activeStep !== 0 && !formCompleted">
              <div class="steps clearfix">
                <ul role="tablist">
                  <li
                    class="first"
                    *ngFor="let step of steps; let i = index"
                    [ngClass]="{ current: i === activeStep - 1 }">
                    <a
                      ><span class="current-info">current step: </span
                      ><span class="number">{{ step.index }}</span>
                      {{ step.title }}</a
                    >
                  </li>
                </ul>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body px-5">
                      <ng-container *ngIf="activeStep === 1">
                        <app-initial-data-form
                          [onNext]="onNextSubject.asObservable()"
                          (nextStep)="nextStep()">
                        </app-initial-data-form>
                      </ng-container>

                      <ng-container *ngIf="activeStep === 2">
                        <app-resident-name
                          [onNext]="onNextSubject.asObservable()"
                          (nextStep)="nextStep()"></app-resident-name>
                      </ng-container>

                      <ng-container *ngIf="activeStep === 3">
                        <app-form-type
                          [onNext]="onNextSubject.asObservable()"
                          (nextStep)="nextStep()"></app-form-type>
                      </ng-container>

                      <ng-container *ngIf="activeStep === 4">
                        <app-assisted-living-form
                          *ngIf="formType === 1"
                          [onNext]="onNextSubject.asObservable()"
                          (nextStep)="nextStep()"></app-assisted-living-form>
                        <app-memory-care-form
                          *ngIf="formType === 2"
                          [onNext]="onNextSubject.asObservable()"
                          (nextStep)="nextStep()"></app-memory-care-form>
                      </ng-container>
                    </div>
                    <div class="card-footer">
                      <div class="row">
                        <div class="col-md-6">
                          <button
                            class="btn btn-soft-success"
                            (click)="backStep()"
                            role="button">
                            Previous Step
                          </button>
                        </div>
                        <div class="col-md-6 text-end">
                          <button
                            class="btn btn-success"
                            (click)="emitOnNext()">
                            Next Step
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="actions clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
